import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BehaviorSubject, map, Observable, Subscription, switchMap, tap } from "rxjs";
import { Schema } from "../../../shared/models/schema.model";
import { SchemaRepository } from "../../../shared/repositories/schema.repository";
import { SessionStoreRepository } from "../../../shared/repositories/session.repository";
import { PatientSchemaTableComponent } from "../../../shared/components/schema-tables/patient-schema-table/patient-schema-table.component";
import { calculatePaginationPages } from "../../../shared/helpers/pagination-helper";
import { LoadingSpinnerBorderComponent } from "../../../shared/components/loading/loading-spinner-border/loading-spinner-border.component";

@Component({
    selector: 'patient-active-schema-list',
    templateUrl: './active-schema-list.component.html',
    styleUrl: './active-schema-list.component.scss',
    imports: [CommonModule, PatientSchemaTableComponent, LoadingSpinnerBorderComponent]
})
export class ActiveSchemaListComponent implements OnInit, OnDestroy {
    private readonly sessionService = inject(SessionStoreRepository);
    private readonly schemaRepository = inject(SchemaRepository);

    private subscription = new Subscription();

    isLoading$ = new BehaviorSubject<boolean>(true).asObservable();
    paginatedSchemas$ = new Observable<Schema[]>;

    isPatient$ = this.sessionService.isPatient$;
    schemas$ = this.schemaRepository.patientActiveSchemas$;
    tabKey: string = "active";

    currentPage: number = 1;
    perPage: number = 10;
    lastPage: number = 1;
    pages: number = 1;
    total: number = 0;
    pagesIntervalSize: number = 5;
    visiblePaginationPages: number[] = [];

    ngOnInit() {
        this.subscription.add(
            this.schemaRepository.getPatientActiveSchemas$().pipe(
                switchMap(() => this.schemaRepository.patientActiveSchemas$),
                tap(schemas => {
                    this.total = schemas.length;
                    this.lastPage = Math.ceil(this.total / this.perPage);
                    this.pages = Math.ceil(this.total / this.perPage);                    
                }),
                map(schemas => {
                    const data = schemas;
                    const paginatedData = data.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
                    return new BehaviorSubject({ paginatedData }).asObservable();
                }),
            ).subscribe(result => {
                this.paginatedSchemas$ = result.pipe(map(x => x.paginatedData));
                this.isLoading$ = this.schemaRepository.patientActiveSchemasIsLoading$;
                this.visiblePaginationPages = calculatePaginationPages(this.currentPage, this.lastPage, this.pages, this.pagesIntervalSize);
            })
        );
    }

    ngOnDestroy(): void {
        if (this.subscription) this.subscription.unsubscribe();
    }

}
